import React from 'react';
import { Utensils } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Loading: React.FC = () => {
  const { t } = useLanguage();
  
  const loadingMessages = [
    t('loading.preparing'),
    t('loading.loadingFlavors'),
    t('loading.preparingKitchen'),
    t('loading.preparingFood'),
    t('loading.bringingMenu')
  ];
  
  const randomMessage = loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="p-8 bg-white rounded-lg shadow-md text-center">
        <div className="mb-6 relative">
          <div className="absolute inset-0 flex items-center justify-center">
            <Utensils className="h-12 w-12 text-blue-500 opacity-20" />
          </div>
          <div className="rounded-full h-24 w-24 border-4 border-blue-100 mx-auto"></div>
          <div className="absolute top-0 left-1/2 -ml-2 w-4 h-24">
            <div className="w-4 h-4 rounded-full bg-blue-500 animate-bounce"></div>
          </div>
        </div>
        
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          {randomMessage}
        </h2>
        <p className="text-gray-500 text-sm">
          {t('loading.pleaseWait')}
        </p>
        
        <div className="mt-6 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-blue-500 to-indigo-600 shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;